

export default function PackClassic() {
    // state

    // comportement

    // affichage
    return (
        <div className="tab-pane fade active show" id="features-tab-1">
            <div className="row">
                <div className="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0 d-flex flex-column justify-content-center">
                    <h3>KIT_YCONNEKT-CLASSIC</h3>
                    <p className="fst-italic">
                        Ce kit permet de couvrir une zone d’environ 300 mètres autour de votre point d’installation, soit environ 50 utilisateurs en simultané. Il convient donc pour les petits espaces à fort trafic, comme les cafés, petites places publiques, ou petits commerces.
                    </p>
                    <ul>
                        <li><i className="bi bi-check2-all"></i> <span>Couverture : 500 m.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>Nombre de client : 100 users max.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>Routeur-yconnekt.</span></li>
                        <li><i className="bi bi-check2-all"></i> <span>02 Antenne wifi.</span></li>
                    </ul>
                    <div className="pricing">
                        <div className="pricing-card">
                            <div className="price">
                                {/* <span className="currency">XAF</span> */}
                                <span className="amount">400.000</span>
                                <span className="period"> FCFA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 order-1 order-lg-2 text-center">
                    <img src="/assets/imgs/pack2.jpg" alt="" className="img-fluid" />
                </div>
            </div>
        </div>
    );
}